var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPage),expression:"showPage"}]}),_vm._v(" "),_c('activity-view',{ref:"aActivityView"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }